<script>
import { required } from 'vuelidate/lib/validators'

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Recommendations from './recommendations'
import Multiselect from 'vue-multiselect'

import axios from 'axios'

export default {
  components: { Multiselect },
  props: {
    title: {
      type: String,
      required: true
    },
	  operation: {
	    type: String,
      required: true
    },
    recommendation: {
      type: Object,
      default: function () {
        return {
          id: null,
          title: null,
          body: null,
          type: null,
          priority: null,
          status: 'Initial',
          tags: []
        }
      }
    }
  },
  data () {
    return {
      category: 'List',
      newTag: null,
      items: [
        {
          text: 'Home',
          href: '/'
        },
        {
          text: 'All Recommendations',
          active: true
        }
      ],
      tagsOptions: [
        'EndPoint',
        'Network',
        'New Threat Global',
        'New Threat Local',
        'CyberThreat Intelligence',
        'Standard',
        'Policy',
        'Cloud',
        'Tentative'
      ],
      optionsType: [
        { value: 'Specific - Technical', text: 'Specific - Technical' },
        { value: 'Generic - Technical', text: 'Generic - Technical' },
        { value: 'Specific - Organizational', text: 'Specific - Organizational' },
        { value: 'Generic - Organizational', text: 'Generic - Organizational' },
        { value: 'Other', text: 'Other' }
      ],
      optionsPriority: [
        { value: 'Critical', text: 'Critical' },
        { value: 'Important', text: 'Important' },
        { value: 'Good Practice', text: 'Good Practice' },
        { value: 'Useful', text: 'Useful' },
        { value: 'Informational', text: 'Informational' }
      ],
      optionsStatus: [
        { value: 'Initial', text: 'Initial' },
        { value: 'Under Review', text: 'Under Review' },
        { value: 'More Information Needed', text: 'More Information Needed' },
        { value: 'Previously Known', text: 'Previously Known' },
        { value: 'Implementing', text: 'Implementing' },
        { value: 'Ignored', text: 'Ignored' },
        { value: 'Disagree', text: 'Disagree' }
      ],
      appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev')
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
	  createNewRecommendation () {
      let that = this
      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      axios.post(`${baseURL}/recommendations/${that.operation}`, that.recommendation).then(response => {
        that.$root.$emit('recommendationCreatedOk')
      }).catch(e => {
        console.log(e)
      })
    },
    newRecommendation () {
      this.$refs['modal-new-recommendation'].show()
    },
    showModal () {
      const that = this
      that.$nextTick(() => {
        that.$refs['modal-new-recommendation'].show()
      })
      // this.$refs['modal-new-recommendation'].show()
    },
    addNewTag () {
      this.recommendation.tags.push(this.newTag)
      this.tagsOptions.push(this.newTag)
    }
  }
}
</script>

<template>
  <div>
    <b-modal
      ref="modal-new-recommendation"
      size="xl"
      :title="title"
      :centered="true"
      :no-fade="true"
      @ok="createNewRecommendation"
    >
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-xl-12 col-sm-12">
                  <div class="form-group mt-3 mt-sm-0">
                    <label for="default">Title</label>
                    <b-form-input
                      id="input-1"
                      v-model="recommendation.title"
                      placeholder="Please be specific..."
                      trim
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-12 col-sm-12">
                  <div class="form-group mt-3 mt-sm-0">
                    <label for="default">Body</label>
                    <b-form-textarea
                      id="textarea-1"
                      v-model="recommendation.body"
                      placeholder="Type the recommendation body here..."
                      rows="4"
                      max-rows="8"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-12 col-sm-12">
                  <div class="form-group mt-3 mt-sm-0">
                    <label for="default">Type</label>
                    <b-form-select
                      id="select-type"
                      v-model="recommendation.type"
                      :options="optionsType"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-12 col-sm-12">
                  <div class="form-group mt-3 mt-sm-0">
                    <label for="default">Priority</label>
                    <b-form-select
                      id="select-priority"
                      v-model="recommendation.priority"
                      :options="optionsPriority"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-12 col-sm-12">
                  <div class="form-group mt-3 mt-sm-0">
                    <label for="default">Status</label>
                    <b-form-select
                      id="select-status"
                      v-model="recommendation.status"
                      :options="optionsStatus"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-xl-6 col-sm-6">
                  <div class="form-group mt-3 mt-sm-0">
                    <label for="default">Tags</label>
                    <multiselect
                      v-model="recommendation.tags"
                      :options="tagsOptions"
                      :multiple="true"
                    />
                  </div>
                </div>
                <div class="col-xl-6 col-sm-6">
                  <div class="form-group mt-3 mt-sm-0">
                    <label for="default">New Tag</label>
                    <div class="col-xl-12 col-sm-12">
                      <div
                        class="form-inline"
                        style="width:100%"
                      >
                        <b-form-input
                          id="input-horizontal"
                          v-model="newTag"
                        />
                    &nbsp;
                        <button
                          type="submit"
                          class="btn btn-primary"
                          @click="addNewTag"
                        >
                          Add
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
